<template>
  <div class="content-layout">
    <div class="property-operations">
      <div class="export-btn-group">
        <label for="fileinp">
          <a-button
            type="primary"
            class="btn"
          >批量导入翻译
            <input
              id="fileinp"
              ref="upload"
              type="file"
              name="filename"
              accept=".xls, .xlsx"
              class="outputlist_upload"
              multiple="multiple"
            >
          </a-button>
        </label>
        <a-button
          type="primary"
          class="add-btn"
          @click="handleExport"
        >
          导出翻译模板
        </a-button>
        <a-button
          v-if="$hasPermissions(['rcs:entry_i18n:update'])"
          class="add-btn"
          type="primary"
          @click="handleAiTranslate"
        >
          AI翻译
        </a-button>
      </div>
      <div class="data-filter">
        <div class="search-switch">
          <a-switch
            v-model="requestParams.translated"
            checked-children="全部"
            un-checked-children="待翻译"
            default-checked
            @change="loadedPageData"
          />
        </div>
        <div>
          <a-select
            v-model="requestParams.translateType"
            allow-clear
            placeholder="翻译类型"
            style="width: 110px;"
            show-search
            option-filter-prop="label"
            @change="loadedPageData"
          >
            <a-select-option :key="2">
              AI翻译
            </a-select-option>
          </a-select>
        </div>
        <div>
          <a-select
            v-model="requestParams.entityId"
            allow-clear
            placeholder="请选择实体"
            show-search
            style="width: 240px;"
            option-filter-prop="label"
            @change="onEntityChange"
          >
            <a-select-option
              v-for="entity in entityList"
              :key="entity.id"
              :label="entity.name"
            >
              {{
                entity.name
              }}
            </a-select-option>
          </a-select>
        </div>
        <div
          v-if="needsExtraFilter"
        >
          <a-select
            v-model="requestParams.productId"
            allow-clear
            placeholder="请选择产品"
            show-search
            option-filter-prop="label"
            style="width: 240px;"
            dropdown-class-name="auto-width-dropdown"
            @change="onProductChange"
          >
            <a-select-option
              v-for="item in productList"
              :key="item.id"
              :label="`${item.name} (ID:${item.id})`"
            >
              {{ item.name }} (ID:{{ item.id }})
            </a-select-option>
          </a-select>
        </div>
        <div
          v-if="needsExtraFilter"
        >
          <a-select
            v-model="requestParams.loadedDeviceTypeId"
            allow-clear
            placeholder="请选择负载设备类型"
            show-search
            option-filter-prop="label"
            style="width: 240px;"
            dropdown-class-name="auto-width-dropdown"
            @change="onLoadedDeviceTypeChange"
          >
            <a-select-option
              v-for="item in filteredLoadedDeviceTypeList"
              :key="item.loadedDeviceTypeId"
              :label="`${item.name} (ID:${item.loadedDeviceTypeId})`"
            >
              {{ item.name }} (ID:{{ item.loadedDeviceTypeId }})
            </a-select-option>
          </a-select>
        </div>
        <div v-if="supportedEntityKey">
          <a-select
            v-model="requestParams.relationId"
            allow-clear
            :placeholder="supportedEntityKey.label"
            show-search
            option-filter-prop="label"
            style="width: 240px;"
            @change="loadedPageData"
          >
            <a-select-option
              v-for="item in filteredRelationDataList"
              :key="item.id || item.identifier"
              :label="item.name"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </div>

        <div>
          <a-select
            v-model="requestParams.languageId"
            allow-clear
            placeholder="请选择语言"
            show-search
            class="short-search-options"
            option-filter-prop="children"
            @change="loadedPageData"
          >
            <a-select-option
              v-for="language in languageList"
              :key="language.id"
            >
              {{ language.name }}
            </a-select-option>
          </a-select>
        </div>
        <div>
          <a-select
            v-model="requestParams.status"
            allow-clear
            placeholder="状态"
            style="width: 100px;"
            option-filter-prop="children"
            @change="loadedPageData"
          >
            <a-select-option :value="$constRepository.entry.status.enable">
              启用
            </a-select-option>
            <a-select-option :value="$constRepository.entry.status.disabled">
              禁用
            </a-select-option>
          </a-select>
        </div>
        <div>
          <a-input
            v-model="requestParams.searchKey"
            clearable
            placeholder="输入词条中文或内容"
            class="search-keyword"
            @keyup.enter.native="doSearch"
          />
        </div>
        <div>
          <a-button
            type="primary"
            @click="doSearch()"
          >
            搜索
          </a-button>
        </div>
      </div>
    </div>
    <a-table
      size="middle"
      :pagination="false"
      :columns="$constRepository.entry.columns"
      :data-source="tableDate"
      class="property-table"
      row-key="id"
    >
      <template #appTag="text">
        <span v-if="text">{{ $constRepository.loadedDevice.ImageTypeLabel[text] || '' }}</span>
      </template>
      <template #translateType="text">
        <span v-if="text">{{ $constRepository.entry.translateTypeLabel[text] || '-' }}</span>
      </template>
      <template #status="text, record, index">
        <a-switch
          checked-children="启用"
          un-checked-children="禁用"
          :disabled="!$hasPermissions(['rcs:entry_i18n:update'])"
          :checked-value="$constRepository.entry.status.enable"
          :un-checked-value="$constRepository.entry.status.disabled"
          :checked="switchStatus(record.status)"
          @change="handleStatusChange(record, index)"
        />
      </template>

      <template #action="scope">
        <a-button
          v-if="$hasPermissions(['rcs:entry_i18n:update'])"
          class="green-btn"
          ghost
          @click="handleEdit(scope)"
        >
          翻译
        </a-button>
      </template>
    </a-table>
    <div class="pagination">
      <a-pagination
        :current="pageInfo.page"
        :show-total="(total) => `共 ${pageInfo.totalElements} 条`"
        show-quick-jumper
        show-size-changer
        :total="pageInfo.totalElements"
        :page-size-options="['10', '20', '30', '40']"
        @showSizeChange="onShowSizeChange"
        @change="onChange"
      />
      <br>
    </div>
    <EntryFormModal ref="entryFormModal" />
    <ExportEntryFormModal ref="exportEntryFormModal" />
    <AiTranslateModal ref="aiEntryFormModal" />
  </div>
</template>

<script>
import moment from 'moment'
import XLSX from 'xlsx'
import EntryFormModal from './components/EntryFormModal'
import ExportEntryFormModal from './components/ExportEntryFormModal'
import AiTranslateModal from './components/AiTranslateModal'

const SUPPORTED_ENTITY_MAP = {
  product: {
    label: '请选择产品',
    fetch(apiManager, params) {
      return apiManager.product.getProducts({ ...params, unpaged: true })
    },
    getElements(response) {
      return (response.data.elements || []).map(item => ({
        id: item.productId,
        name: item.name,
      }))
    },
  },
  loadedDeviceType: {
    label: '请选择负载类型',
    fetch(apiManager, params) {
      return apiManager.loadedDeviceType.getLoadedDeviceTypes({ ...params, unpaged: true })
    },
    getElements(response) {
      return response.data.elements || []
    },
  },
  region: {
    label: '请选择区域',
    fetch(apiManager, params) {
      return apiManager.region.getRegions({ ...params, unpaged: true })
    },
    getElements(response) {
      return (response.data.elements || []).map(item => ({
        id: item.identifier,
        name: item.name,
      }))
    },
  },
  sceneType: {
    label: '请选择场景类型',
    fetch(apiManager, params) {
      return apiManager.scenceType.getScenceTypeList({ ...params, unpaged: true }, {})
    },
    getElements(response) {
      return (response.data.elements || []).filter(item => item.id && item.name)
    },
  },
  productClass: {
    label: '请选择产品大类',
    fetch(apiManager, params) {
      return apiManager.productClasses.getProductClasses({ ...params, unpaged: true })
    },
    getElements(response) {
      return (response.data.elements || []).filter(item => item.id && item.name)
    },
  },
  properties: {
    label: '请选择属性',
    fetch(apiManager, params) {
      return apiManager.property.getProperties({ ...params, unpaged: true })
    },
    getElements(response) {
      return (response.data.elements || []).map(item => ({
        id: item.encode,
        name: item.name,
      }))
    },
  },
  productServiceItems: {
    label: '请选择产品服务项',
    fetch(apiManager, params) {
      return apiManager.productService.getProductService({ ...params, unpaged: true })
    },
    getElements(response) {
      return (response.data.elements || []).map(item => ({
        id: item.encode,
        name: item.name,
      }))
    },
  },
  productConfigurationItems: {
    label: '请选择产品配置项',
    fetch(apiManager, params) {
      return apiManager.productConfiguration.getProductConfigurationItems({ ...params, unpaged: true })
    },
    getElements(response) {
      return (response.data.elements || []).map(item => ({
        id: item.encode,
        name: item.name,
      }))
    },
  },
}

export default {
  name: 'EntryManagement',
  components: { EntryFormModal, ExportEntryFormModal, AiTranslateModal },
  data() {
    return {
      searchKeyword: '',
      requestParams: {
        translated: false,
      },
      tableDate: [],
      moment,
      entityList: [],
      languageList: [],
      relationDataList: [],
      productList: [],
      loadedDeviceTypeList: [],
      selectedProductLoadedDeviceTypeIds: null,
      selectedLoadedDeviceTypePropertyEncodes: null,
      excelData: [],
      pageInfo: {
        page: 1,
        size: 10,
        totalElements: 0,
        totalPages: 0,
      },
    }
  },
  computed: {
    switchStatus: {
      get() {
        return status => status === this.$constRepository.entry.status.enable
      },
    },
    selectedEntity() {
      if (!this.requestParams.entityId)
        return null
      return this.entityList.find(e => e.id === this.requestParams.entityId)
    },
    supportedEntityKey() {
      if (!this.selectedEntity)
        return null
      const entityName = this.selectedEntity.entity
      const key = Object.keys(SUPPORTED_ENTITY_MAP).find(k => k.toLowerCase() === entityName.toLowerCase())
      return key ? SUPPORTED_ENTITY_MAP[key] : null
    },
    needsExtraFilter() {
      if (!this.selectedEntity)
        return false
      const entityName = this.selectedEntity.entity
      const filteredEntities = ['productConfigurationItems', 'productServiceItems', 'loadedDeviceTypeAliasRule', 'properties']
      return filteredEntities.some(e => e.toLowerCase() === entityName.toLowerCase())
    },
    isPropertiesEntity() {
      return this.selectedEntity && this.selectedEntity.entity.toLowerCase() === 'properties'
    },
    filteredLoadedDeviceTypeList() {
      if (!this.selectedProductLoadedDeviceTypeIds)
        return this.loadedDeviceTypeList
      return this.loadedDeviceTypeList.filter(item => this.selectedProductLoadedDeviceTypeIds.includes(item.loadedDeviceTypeId))
    },
    filteredRelationDataList() {
      if (!this.isPropertiesEntity || !this.selectedLoadedDeviceTypePropertyEncodes)
        return this.relationDataList
      return this.relationDataList.filter(item => this.selectedLoadedDeviceTypePropertyEncodes.includes(item.id))
    },
  },
  activated() {
    this.loadedPageData()
    this.listI18nEntities()
    this.listLanguages()
    this.$refs.upload.addEventListener('change', (e) => {
      this.readExcel(e)
    })
  },
  methods: {
    doSearch() {
      this.pageInfo.page = 1
      this.loadedPageData()
    },
    onEntityChange() {
      this.$set(this.requestParams, 'relationId', undefined)
      this.$set(this.requestParams, 'productId', undefined)
      this.$set(this.requestParams, 'loadedDeviceTypeId', undefined)
      this.selectedProductLoadedDeviceTypeIds = null
      this.selectedLoadedDeviceTypePropertyEncodes = null
      this.relationDataList = []
      if (this.supportedEntityKey)
        this.fetchRelationData()

      if (this.needsExtraFilter)
        this.fetchExtraFilterData()

      this.loadedPageData()
    },
    async onProductChange(productId) {
      this.$set(this.requestParams, 'loadedDeviceTypeId', undefined)
      if (this.isPropertiesEntity)
        this.$set(this.requestParams, 'relationId', undefined)

      this.selectedLoadedDeviceTypePropertyEncodes = null
      if (productId) {
        try {
          const response = await this.$apiManager.product.getProductById(productId, { 'FULL-PRODUCT': true })
          this.selectedProductLoadedDeviceTypeIds = response.data.loadedDeviceTypeIds || []
        }
        catch {
          this.selectedProductLoadedDeviceTypeIds = null
        }
      }
      else {
        this.selectedProductLoadedDeviceTypeIds = null
      }
      this.loadedPageData()
    },
    async onLoadedDeviceTypeChange(loadedDeviceTypeId) {
      this.$set(this.requestParams, 'relationId', undefined)
      if (this.isPropertiesEntity && loadedDeviceTypeId) {
        try {
          const response = await this.$apiManager.loadedDeviceType.getLoadedDeviceTypeById({ loadedDeviceTypeId })
          this.selectedLoadedDeviceTypePropertyEncodes = (response.data.properties || []).map(p => p.encode)
        }
        catch {
          this.selectedLoadedDeviceTypePropertyEncodes = null
        }
      }
      else {
        this.selectedLoadedDeviceTypePropertyEncodes = null
      }
      this.loadedPageData()
    },
    async fetchRelationData() {
      if (!this.supportedEntityKey)
        return
      const { fetch, getElements } = this.supportedEntityKey
      const params = {}
      if (this.requestParams.relationId)
        params.relationId = this.requestParams.relationId

      const response = await fetch(this.$apiManager, params)
      this.relationDataList = getElements(response)
    },
    async fetchExtraFilterData() {
      const [productRes, loadedDeviceTypeRes] = await Promise.all([
        this.$apiManager.product.getProducts({ unpaged: true }),
        this.$apiManager.loadedDeviceType.getLoadedDeviceTypes({ unpaged: true }),
      ])
      this.productList = (productRes.data.elements || []).map(item => ({
        id: item.productId,
        name: item.name,
      })).sort((a, b) => a.id - b.id)
      this.loadedDeviceTypeList = (loadedDeviceTypeRes.data.elements || []).sort((a, b) => a.loadedDeviceTypeId - b.loadedDeviceTypeId)
    },
    aiTranslateAction() {
      this.pageInfo.page = 1
      this.loadedPageData()
    },
    async listEntry() {
      const params = {
        translated: this.requestParams.translated,
        status: this.requestParams.status,
        searchKey: this.requestParams.searchKey,
        languageId: this.requestParams.languageId,
        page: this.pageInfo.page - 1,
        size: this.pageInfo.size,
      }
      if (this.requestParams.translateType)
        params.translateType = this.requestParams.translateType

      if (this.requestParams.relationId)
        params.relationId = this.requestParams.relationId

      if (this.requestParams.productId)
        params.productId = this.requestParams.productId

      if (this.requestParams.loadedDeviceTypeId)
        params.loadedDeviceTypeId = this.requestParams.loadedDeviceTypeId

      const response = await this.$apiManager.entry.getEntries(
        this.requestParams.entityId ? this.requestParams.entityId : '-',
        params,
      )
      this.tableDate = response.data.elements
      this.$set(this.pageInfo, 'totalElements', response.data.totalElements)
      this.$set(this.pageInfo, 'totalPages', response.data.totalPages)
      this.$set(this.pageInfo, 'currentPage', response.data.currentPage)
    },
    async loadedPageData() {
      await this.listEntry()
      if (this.pageInfo.currentPage + 1 > this.pageInfo.totalPages && this.pageInfo.currentPage) {
        this.pageInfo.page = 1
        await this.listEntry()
      }
    },
    handleEdit(record) {
      this.$refs.entryFormModal.showDialog(record, (entryForm) => {
        this.$apiManager.entry.updateEntry(entryForm).then(() => {
          this.$message.success('翻译成功')
          this.loadedPageData()
        })
      })
    },
    updateEntries(entries, info = '翻译成功') {
      this.$apiManager.entry.updateEntries(entries).then(() => {
        this.$message.success(info)
        this.loadedPageData()
      })
    },
    handleExport() {
      const params = {
        entityList: this.entityList,
        languageList: this.languageList,
      }
      this.$refs.exportEntryFormModal.showDialog(params, this.exportExcel)
    },
    handleAiTranslate() {
      const params = {
        entityList: this.entityList,
        languageList: this.languageList,
      }
      this.$refs.aiEntryFormModal.showDialog(params)
    },
    onShowSizeChange(current, pageSize) {
      this.pageInfo.page = 1
      this.$set(this.pageInfo, 'size', pageSize)
      this.loadedPageData()
    },
    onChange(pageNumber) {
      this.$set(this.pageInfo, 'page', pageNumber)
      this.loadedPageData()
    },
    statusName(status) {
      if (status === this.$constRepository.entry.status.enable)
        return '启用'

      if (status === this.$constRepository.entry.status.disabled)
        return '禁用'

      return '未知'
    },
    async listI18nEntities() {
      const response = await this.$apiManager.i18nEntity.getI18nEntities({ unpaged: true })
      this.entityList = response.data.elements
    },
    async listLanguages() {
      const response = await this.$apiManager.language.getLanguages({ unpaged: true })
      this.languageList = response.data.elements
    },
    async exportExcel(requestParams) {
      if (requestParams.languageId && requestParams.entityId) {
        const params = {
          translated: requestParams.translated,
          status: this.$constRepository.entry.status.enable,
          languageId: requestParams.languageId,
          unpaged: true,
        }
        const response = await this.$apiManager.entry.getEntries(requestParams.entityId, params)
        if (response.data.elements.length) {
          const wb = XLSX.utils.book_new()
          const json = response.data.elements.map(entry => ({
            id: entry.id,
            entityId: entry.entityId,
            key: entry.key,
            实体: entry.entity,
            语言编号: entry.languageId,
            应用标签: entry.appTag ? this.$constRepository.loadedDevice.ImageTypeLabel[entry.appTag] : '',
            词条上下文: entry.context,
            中文内容: entry.curCN,
            翻译内容: entry.value,
          }))
          const entityName = requestParams.entityId === '-' ? '全部' : `${json[0].实体}`
          const filename = `${entityName}实体${requestParams.languageId}语言翻译内容.xlsx`
          const wsName = 'SheetJS'
          const ws = XLSX.utils.json_to_sheet(json, { raw: true })
          XLSX.utils.book_append_sheet(wb, ws, wsName)
          XLSX.writeFile(wb, filename)
        }
        else {
          this.$message.warning('该词条实体无数据')
        }
      }
      else {
        this.$message.warning('请选择需要导出的实体和语言')
      }
    },
    readExcel(e) {
      const { files } = e.target
      if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase()))
        this.$message.error('上传格式不正确，请上传xls或者xlsx格式')

      for (let i = 0; i < files.length; i += 1)
        this.analysisExcel(files[i])
    },
    analysisExcel(file) {
      const fileReader = new FileReader(file)
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result
          const workbook = XLSX.read(data, {
            type: 'binary',
            raw: true,
          })
          const wsname = workbook.SheetNames[0] // 取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], { raw: true }) // 生成json表格内容
          // 编辑数据
          const params = []
          ws.forEach((entry) => {
            const newData = {
              id: entry.id,
              entityId: entry.entityId,
              key: entry.key,
              languageId: entry.语言编号,
              value: entry.翻译内容,
              context: entry.词条上下文,
            }
            if (newData.value || newData.value === 0)
              params.push(newData)
          })
          this.updateEntries(params, '导入成功')
        }
        catch (error) {
          this.$message.error('导入失败')
        }
      }
      return fileReader.readAsBinaryString(file)
    },
    handleStatusChange(record, index) {
      const params = record
      params.status = record.status === 1 ? 2 : 1
      this.$apiManager.entry.updateEntryStatus(params).then(() => {
        this.$message.success('更新状态成功')
        this.loadedPageData()
      }).catch(() => {
        params.status = record.status === 2 ? 1 : 2
        this.$set(this.tableDate, index, { ...params })
      })
    },
  },
}
</script>

<style lang="less" scoped>
.content-layout {
  height: auto;
}

.green-btn {
  color: green;
  border: none;
}

.red-btn {
  color: red;
  border: none;
}

#fileinp {
  float: left;
  margin-left: 2%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;

  .btn {
    margin-left: 2%;
  }
}

.property-operations {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1%;

  .export-btn-group {
    width: 21rem;
  }

  .add-btn {
    // margin: 10px 0px;
    margin-left: 3%;
  }

  .data-filter {
    width: calc(100% - 22rem);
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: wrap;
    gap:10px;
    .tip {
      color: #4c4c4c;
    }

    .date-picker-style {
      margin: 0 10px;
    }

    .search-switch {
      width: 80px;
    }

    .search-options {
      width: 200px;
      margin-right: 1%;
    }

    .short-search-options {
      width: 140px;
    }

    .search-keyword {
      width: 160px;
    }

    .search-btn {
      // margin: 10px 0px;
      margin-left: 3%;
    }
  }

}

.property-table {
  margin-top: 1%;
}

.pagination {
  margin-top: 3%;
}
</style>

<style lang="less">
.auto-width-dropdown {
  .ant-select-dropdown-menu-item {
    white-space: normal;
    word-break: break-all;
  }
}
</style>
